// @generated by protoc-gen-es v2.11.0 with parameter "target=ts,import_extension=none"
// @generated from file chalk/utils/v1/field_change.proto (package chalk.utils.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file chalk/utils/v1/field_change.proto.
 */
export const file_chalk_utils_v1_field_change: GenFile = /*@__PURE__*/
  fileDesc("CiFjaGFsay91dGlscy92MS9maWVsZF9jaGFuZ2UucHJvdG8SDmNoYWxrLnV0aWxzLnYxIq0BCgtGaWVsZENoYW5nZRISCgpmaWVsZF9uYW1lGAEgASgJEhsKDnByZXZpb3VzX3ZhbHVlGAIgASgJSACIAQESFgoJbmV3X3ZhbHVlGAMgASgJSAGIAQESNAoObmVzdGVkX2NoYW5nZXMYBCADKAsyHC5jaGFsay51dGlscy52MS5OZXN0ZWRDaGFuZ2VCEQoPX3ByZXZpb3VzX3ZhbHVlQgwKCl9uZXdfdmFsdWUicgoMTmVzdGVkQ2hhbmdlEgwKBHBhdGgYASABKAkSGwoOcHJldmlvdXNfdmFsdWUYAiABKAlIAIgBARIWCgluZXdfdmFsdWUYAyABKAlIAYgBAUIRCg9fcHJldmlvdXNfdmFsdWVCDAoKX25ld192YWx1ZWIGcHJvdG8z");

/**
 * @generated from message chalk.utils.v1.FieldChange
 */
export type FieldChange = Message<"chalk.utils.v1.FieldChange"> & {
  /**
   * @generated from field: string field_name = 1;
   */
  fieldName: string;

  /**
   * null = field didn't exist before (added)
   *
   * @generated from field: optional string previous_value = 2;
   */
  previousValue?: string;

  /**
   * null = field was removed (unset)
   *
   * @generated from field: optional string new_value = 3;
   */
  newValue?: string;

  /**
   * primarily used for maps and repeated fields
   *
   * @generated from field: repeated chalk.utils.v1.NestedChange nested_changes = 4;
   */
  nestedChanges: NestedChange[];
};

/**
 * Describes the message chalk.utils.v1.FieldChange.
 * Use `create(FieldChangeSchema)` to create a new message.
 */
export const FieldChangeSchema: GenMessage<FieldChange> = /*@__PURE__*/
  messageDesc(file_chalk_utils_v1_field_change, 0);

/**
 * @generated from message chalk.utils.v1.NestedChange
 */
export type NestedChange = Message<"chalk.utils.v1.NestedChange"> & {
  /**
   * @generated from field: string path = 1;
   */
  path: string;

  /**
   * null = field didn't exist before (added)
   *
   * @generated from field: optional string previous_value = 2;
   */
  previousValue?: string;

  /**
   * null = field was removed (unset)
   *
   * @generated from field: optional string new_value = 3;
   */
  newValue?: string;
};

/**
 * Describes the message chalk.utils.v1.NestedChange.
 * Use `create(NestedChangeSchema)` to create a new message.
 */
export const NestedChangeSchema: GenMessage<NestedChange> = /*@__PURE__*/
  messageDesc(file_chalk_utils_v1_field_change, 1);

